import { Button, classnames, NumberedList, Title } from '@terveystalo/design-system-react-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Has list of use cases
type Props = {
  onClickNext: () => void;
};

export const InfoPage: FC<Props> = ({ onClickNext }) => {
  const { t } = useTranslation();
  return (
    <div className={classnames('flex', 'flex-col', 'mb-2')}>
      <Title as="h1" size="xl" weight="normal" className={classnames('mb-1')}>
        {t('start_by_giving_anamnesis')}
      </Title>
      <div className={classnames('px-1', 'flex', 'flex-col', 'mb-2')}>
        <NumberedList>
          {[
            t('choose_what_symptoms_you_have'),
            t('answer_to_specifying_questions'),
            t('check_summary_and_continue_to_chat'),
          ]}
        </NumberedList>
      </div>
      <Button id="start-questionnaire-button" as="button" onClick={onClickNext}>
        {t('start_preliminary_questionaire')}
      </Button>
    </div>
  );
};
